import Utils from '../common/Utils';
import {GLOBAL_PATH, STORE} from '../common/Model';

export default class Cmbest {
	constructor(_config) {

		this.config = _config;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'cmbest',
			locale : this.config.locale,
			country : this.config.country
		};
		this.cmbestApiUrl = GLOBAL_PATH(_option);
	}
	init() {
		if (Utils.isEmptyObject(STORE.data.cmbest) ) {
			this.get();
		} else {
			this.render(STORE.data.cmbest);
		}
	}

	get() {
		const _this = this;
		fetch(this.cmbestApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.cmazit = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.cmbestApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.cmbest = _resData;
			this.render(_resData);
		});*/
	}
	render(data) {
		const wrapper = document.querySelector('.cmbest-wrapper');
		if(! data.isActive) {
			wrapper.remove();
		} else {
			const tmpl = this.templ(data.list, data.title); // isActive:true 일 경우에만 렌더 하자
			if(data && data.list.length > 0) wrapper.innerHTML = tmpl;
		}
	}

	templ(_d, _tit){
		let _title = `<h3>${_tit}</h3>`;
		return `
			<header class="cmbest-header">
			${_title}
			</header>
			<article class="cmbest-list" ${this.config.isRtl ? 'dir="rtl"' : '' }>
				${_d.map( (item, index) => {
				return this.listTempl(item); // if(index<6) 
				}).join('')}
			</article>`;
	}

	listTempl(_a) {
		let _hasMovie = _a.hasMovie ? `<div class="cmbest-info"><i class="icon-play"></i></div>` : ``;
		return `
			<div class="cmbest-item ${_a.thumb ? 'has-thumb' : ''}">
                <a class="cmbest-link" href="${_a.url}">
                    <div class="cmbest-text">
                        <div class="cmbest-title">${_a.title}</div>
                        <div class="cmbest-writer">${_a.writer}</div>
                    </div>
                    ${_a.thumb ? `<div class="cmbest-thumb"><img src="${_a.thumb}" alt="">${_hasMovie}</div>` : ``}
                </a>
            </div>`;
	}
}